<template>
  <div>
    <video-header ></video-header>
    <div class="py-36 h-screen">
      <h1>hi video</h1>
      <video-player :options="videoOptions"/>
    </div>
  </div>
</template>

<script>
import VideoHeader from '../components/VideoHeader.vue';
import VideoPlayer from "../components/VideoPlayer.vue";
import path from 'path';

export default {
  components: {
    VideoHeader,
    VideoPlayer
  },
  data() {
		return {
			videoOptions: {
				autoplay: true,
				controls: true,
				sources: [
					{
						src: path.join(__dirname, 'assets', 'video_presentation.mp4'),
            type: "video/mp4"
					}
				]
			}
		};
	}
}
</script>

<style>

</style>